module.exports = __webpack_public_path__ + "images/emoji/heartbeat.163713b06404ca25bc08.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heartbeat.png
// module id = 1LV8
// module chunks = 13